import { BotbPassModalContext } from "./botb-pass-modal-context";
import { ReactNode, useEffect, useState } from "react";
import { useAppDispatch } from "../../../../redux/hooks";
import { getAvailableSubscriptions } from "../../../../(general-header)/botb-pass/subscription-service";
import { getPreSubscriptionData } from "../../../../(general-header)/upsell-subscription-modal/subscription-service";
import { publishModalVisibility } from "../../../../redux/features/modal/modalSlice";
import { getPrizeData } from "../../../../components/PrizeTicketSelector/prize-ticket-selector-service";
import { PrizeTicketProps } from "../../../../components/PrizeTicketSelector/types";
import { useCompetition } from "../../../../redux/features/categories/selectors";

const BotbPassModalProvider = ({ children, place = "" }: { children: ReactNode; place?: string }) => {
  const dispatch = useAppDispatch();
  const [allPackages, setAllPackages] = useState<Package[]>([]);
  const hcCompetition = useCompetition({
    CompetitionTypePrefix: "HC",
  });
  const [preSubscriptionData, setPreSubscriptionData] = useState<PreSubscriptionData>({
    features: [],
    header: {
      subtitlep1: "",
      subtitlep2: "",
      subtitlep3: "",
      title: "",
      video: "",
      videoMobile: "",
      legalText: "",
    },
    offer: {
      bonus: "",
      description: "",
      expireTime: 0,
      headline: "",
      offerImage: "",
    },
  });
  const [preSubscriptionDataLoading, setPreSubscriptionDataLoading] = useState<boolean>(false);
  const [prizeTicketProps, setPrizeTicketProps] = useState<PrizeTicketProps>({
    CompetitionType: 0,
    CompetitionTypePrefix: "",
    PostalEntryText: "",
    PrizeTicketModel: {
      PrizeBoostPromoText: "",
      CompetitionId: 0,
      CompetitionPictureTitle: "",
      ContentNodeId: 0,
      CurrencySymbol: "",
      DefaultTicketCount: 0,
      FormattedOriginalPrice: "",
      FormattedPrice: "",
      FormattedPriceWithoutCurrency: "",
      ImageUrl: "",
      IncrementAmount: 0,
      IsMultiBuyActive: false,
      IsMultiBuyForFirstPurchase: false,
      IsRewardTicket: false,
      Make: "",
      MaxTicketQuantity: 0,
      Model: "",
      MultiBuyEndDay: 0,
      MultiBuyEndHour: 0,
      MultiBuyEndMinute: 0,
      MultiBuyEndMonth: 0,
      MultiBuyEndSecond: 0,
      MultiBuyEndYear: 0,
      MultiBuyLowerPercent: 0,
      MultiBuyLowerQuantity: 0,
      MultiBuyUpperPercent: 0,
      MultiBuyUpperQuantity: 0,
      OverrideDiscountValue: "",
      PercentOffValue: 0,
      PriceWithoutCurrency: 0,
      PrizeBoostEndDate: 0,
      PrizeBoostImageUrl: "",
      PrizeBoostLowerQuantity: 0,
      PrizeBoostLowerValue: 0,
      PrizeBoostUpperQuantity: 0,
      PrizeBoostUpperValue: 0,
      PrizeId: 0,
      ProductId: 0,
      QuickBuyFirstButtonValue: 0,
      QuickBuySecondButtonValue: 0,
      QuickBuyThirdButtonValue: 0,
      RemainingRewardTickets: {
        AllAvailableRewardTickets: 0,
        HasRewardTicketsInCart: false,
        RewardTickets: [],
        ServerTime: undefined,
      },
      ShowInstantWinText: false,
      ShowTicketMaxOnSlider: false,
      StartAmount: 0,
      SubscriptionTickets: 0,
      SupportsMultibuy: false,
      TicketSelectorMode: undefined,
      UserCanPurchase: false,
      UserPurchaseMessage: "",
    },
    ShowSubscriptionTab: false,
    UTMForSubscriptionDrawer: "",
    UTMForSubscriptionTab: "",
  });

  const createSortedData = (data: Package[]) => {
    return [...data].sort(
      (a, b) =>
        a.prices.find(price => price.interval === "month").unit_amount -
        b.prices.find(price => price.interval === "month").unit_amount
    );
  };

  useEffect(() => {
    getAvailableSubscriptions()
      .then(res => res.json())
      .then(res => {
        if (res !== null) {
          setAllPackages(createSortedData(res));
        }
      })
      .catch(err => console.error(err));
    setPreSubscriptionDataLoading(true);
    getPreSubscriptionData(false, "default")
      .then(res => res.json())
      .then(res => {
        setPreSubscriptionData(res);
        setPreSubscriptionDataLoading(false);
      })
      .catch(err => console.error(err));
  }, []);

  useEffect(() => {
    if (hcCompetition.FeaturedPrizeId) {
      getPrizeData(String(hcCompetition.FeaturedPrizeId))
        .then(res => res.json() as Promise<PrizeTicketProps>)
        .then(setPrizeTicketProps)
        .catch(err => {
          console.error(err);
        });
    }
  }, [hcCompetition]);

  const closeModal = () => {
    dispatch(publishModalVisibility({ isOpen: false }));
  };

  return (
    <BotbPassModalContext.Provider
      value={{
        allPackages,
        preSubscriptionData,
        preSubscriptionDataLoading,
        closeModal,
        prizeTicketProps,
        place,
      }}>
      {children}
    </BotbPassModalContext.Provider>
  );
};

export default BotbPassModalProvider;
